import Model from '@/lib/data/Model';

class SurveyInfo extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'visit_id',
        'parent_id',
        'f_name',
        'f_type',
        'floor',
        'building_type_id',
        'occupancy_type_id',
        'survey_type_id',
    ];

    constructor(data) {
        super(data);
        this.init();
    }
}

export default SurveyInfo;
